@if (isLoading) {
<div class="ContenLoanding m-0 p-0">
  <div class="grid text-center spinnerBeloHorizonte">
    <div class="col-12 imageMedia">
      <img class="border-round" src="../../../../../assets/logo/evokecolor.png">
    </div>
    <div class="col-12">
      <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)"
        animationDuration=".5s"></p-progressSpinner>
      @if (isRecognition) {
      <label>
        <h1 class="colorAccess">Estamos procesando tus imágenes.
          Esto puede tardar entre 5 y 10 minutos, por favor no recargues la página.</h1>
      </label>
      }@else {
      <label>
        <h1 class="colorAccess">Cargando...</h1>
      </label>
      }
    </div>
  </div>
</div>
}